@if (isVisible()) {
  <div
    class="fixed bottom-0 inset-x-0 z-1000 bg-white shadow-[0_-4px_12px_rgba(0,0,0,0.08)] border-t border-gray-200 p-3 pb-safe-min-3"
    role="region"
    aria-label="Install app banner"
    i18n-aria-label
  >
    <div class="mx-auto max-w-[800px] flex items-center gap-2">
      <img
        [src]="storeConfig.iconPath"
        [alt]="storeConfig.appName"
        class="h-11 w-11 rounded-xl object-contain mr-1"
      />
      <div class="min-w-0 flex-1">
        <p class="font-semibold text-gray-900 leading-tight truncate">
          {{ storeConfig.appName }}
        </p>
        <p class="text-[10px] text-gray-600 leading-tight whitespace-normal">
          {{ storeConfig.tagline }}
        </p>
      </div>

      <button
        (click)="openStore()"
        class="shrink-0 rounded-full bg-primary-500 hover:bg-primary-600 text-white px-3 py-1.5 text-sm font-semibold transition-colors"
        i18n
      >
        Install
      </button>
      <button
        type="button"
        class="shrink-0 text-gray-500 hover:text-gray-800 p-2 -mr-2 cursor-pointer"
        (click)="dismiss()"
        aria-label="Close app banner"
        i18n-aria-label
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
}
